import { useQuery } from '@tanstack/react-query'
import { getWebsitePages } from 'src/editor/api/website-pages-api'
import { GetWebsitePagesResponse } from 'src/editor/store/website-pages/website-pages-types'

export const websitePagesQueryKey = (websiteId: number) => [
  'websiteTheme',
  websiteId,
]

type Updater = (prevData: GetWebsitePagesResponse) => GetWebsitePagesResponse

export const setWebsitePagesQueryDataArgs = (
  websiteId: number,
  updater: Updater,
): [
  readonly unknown[],
  Updater,
] => [websitePagesQueryKey(websiteId), updater]

export const useQueryWebsitePages = (websiteId: number) =>
  useQuery({
    queryKey: websitePagesQueryKey(websiteId),
    queryFn: () => getWebsitePages(websiteId),
    staleTime: 1000 * 60 * 5,
  })
